export type TeceoInputConfig = {
  size: 'small' | 'medium' | 'large';
  variant: 'outlined';
  fullWidth: boolean;
};

const teceoInputConfig: TeceoInputConfig = { size: 'medium', variant: 'outlined', fullWidth: true };
export default teceoInputConfig;
